import styled from 'styled-components'
import { Card as CardComponent } from '@superhi/design'

export const Card = styled(CardComponent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`
